module.exports = __webpack_public_path__ + "static/media/RNG.7aecd79e.svg";